"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCreateNewAdminAccountProfileRequest = exports.validateCreateNewAdminAccountMethodRequest = exports.CreateNewAdminAccountSchema = exports.CreateNewAdminAccountProfileSchema = void 0;
const yup = __importStar(require("yup"));
const User_1 = require("./User");
const ValidationError_1 = require("../errors/ValidationError");
/**
 * Schema for create new admin account method validation
 * {@link ICreateNewAdminAccountRequestBody}
 */
const CreateNewAdminAccountSchema = yup.object().shape({
    salutation: User_1.UserSchema.salutation,
    firstName: User_1.UserSchema.firstName,
    secondName: User_1.UserSchema.secondName,
    thirdName: User_1.UserSchema.thirdName,
    familyName: User_1.UserSchema.familyName,
    email: yup.string().email().required("Please enter email").max(255),
    password: User_1.UserSchema.password,
    confirmPassword: User_1.UserSchema.confirmPassword,
    tncAccepted: yup.boolean().oneOf([true], "Must accept terms & conditions").required("Must accept terms & conditions"),
});
exports.CreateNewAdminAccountSchema = CreateNewAdminAccountSchema;
const CreateNewAdminAccountProfileSchema = yup.object().shape({
    salutation: User_1.UserSchema.salutation,
    firstName: User_1.UserSchema.firstName,
    secondName: User_1.UserSchema.secondName,
    thirdName: User_1.UserSchema.thirdName,
    familyName: User_1.UserSchema.familyName,
    email: yup.string().email().required("Please enter email").max(255),
    tncAccepted: yup.boolean().oneOf([true], "Must accept terms & conditions").required("Must accept terms & conditions"),
});
exports.CreateNewAdminAccountProfileSchema = CreateNewAdminAccountProfileSchema;
/**
 * Validates create new admin account method request schema
 * @param data: create new admin account method request {@link ICreateNewAdminAccountRequestBody} to validate
 */
const validateCreateNewAdminAccountMethodRequest = async (data) => {
    try {
        await CreateNewAdminAccountSchema.validate(data, {
            abortEarly: false,
        });
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
};
exports.validateCreateNewAdminAccountMethodRequest = validateCreateNewAdminAccountMethodRequest;
/**
 * Validates the password-less profile-step payload of an enforced invitation
 * {@link ICreateNewAdminAccountProfileRequestBody}
 */
const validateCreateNewAdminAccountProfileRequest = async (data) => {
    try {
        await CreateNewAdminAccountProfileSchema.validate(data, {
            abortEarly: false,
        });
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
};
exports.validateCreateNewAdminAccountProfileRequest = validateCreateNewAdminAccountProfileRequest;
//# sourceMappingURL=CreateNewAdminAccount.js.map